import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "Does my business need cloud support services if we have an internal IT team?",
    answer: `<p>Cloud support services can significantly boost the functional and technical capacity of your internal IT team. We have clients with internal teams that, with TekRevol’s Cloud support, are achieving faster deployment and ongoing development targets.</p>`,
  },
  {
    question: "What is included in your Cloud support services?",
    answer: `<p>We have a comprehensive suite of cloud support services that include full-cycle cloud infrastructure maintenance services as well as independent cloud security services, disaster recovery, backup management and business continuity campaigns, patch management, incident identification and resolution and initial cloud configuration.</p>`,
  },
  {
    question:
      "How do you know if TekRevol is the right cloud support service provider for my business?",
    answer: `<p>We have a client retention rate of 98% and maintain a 4.8 stars rating on B2B independent rating and review platforms. While these speak volumes about TekRevol’s credibility, we would like to invite you to a quick one-on-one validation session with our Assistant Vice President of Cloud Strategy to discuss major business use cases.</p>`,
  },
  {
    question: "Which associated IT support and cloud services do you provide?",
    answer: `<p>At TekRevol, we provide full-scale Cloud services including cloud migration, cloud consulting, cloud consultancy and cloud managed services.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Cloud Support And Maintenance FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
